/// <amd-module name="Artifacts/Root/containers/ArtifactsRoot" />
import { PerfScenarios } from "Artifacts/Root/Constants";
import { RootModule } from "Artifacts/Root/redux/Module";
import { RootRouter } from "Artifacts/Root/routing/RootRouter";
import * as React from "react";
import { Components, IVssComponentProperties, useComponentContext } from "VSS/Platform/Layout";
import { RootProvider } from "VSS/Redux/RootProvider";

const ArtifactsRoot: React.FC<IVssComponentProperties> = () => {
  const context = useComponentContext();

  return (
    <RootProvider
      initialState={{}}
      scenarioName={PerfScenarios.Area}
      sagaContext={context}
      modules={[RootModule]}
      useStoreService={true}
    >
      <div className="artifacts-root-container flex flex-grow flex-column">
        <RootRouter pageContext={context.pageContext} />
      </div>
    </RootProvider>
  );
};

Components.add("ms.azure-artifacts.artifacts-root", ArtifactsRoot);
